import * as React from "react";
import type { SVGProps } from "react";
export const SvgNavSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M6.635 1.473a6.66 6.66 0 0 1 2.727-.001 2.662 2.662 0 0 0 2.436 2.258c.399.03.8-.03 1.172-.176a6.66 6.66 0 0 1 1.362 2.363 2.662 2.662 0 0 0-1 2.083c0 .843.39 1.594 1.001 2.083a6.696 6.696 0 0 1-1.364 2.362 2.663 2.663 0 0 0-3.606 2.08c-.9.19-1.828.19-2.728.003a2.662 2.662 0 0 0-2.435-2.26c-.4-.03-.8.03-1.173.177a6.659 6.659 0 0 1-1.362-2.364 2.661 2.661 0 0 0 .738-3.237 2.662 2.662 0 0 0-.739-.927 6.695 6.695 0 0 1 1.364-2.362 2.662 2.662 0 0 0 3.173-.98c.225-.33.374-.706.434-1.101ZM7.999 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    />
  </svg>
);
